import i18next from 'i18next'
import { toCapitalized } from '../helpers/others'

class GymBuilderService {
  static toUiMemberFields(fields?: Dto.MemberField[] | null) {
    const labels = new Map([
      ['first-name', i18next.t('First name')],
      ['last-name', i18next.t('Last name')],
      ['email', i18next.t('Email address')],
      ['mobile', i18next.t('Mobile')],
      ['dob', i18next.t('Date of birth')],
      ['gender', i18next.t('Gender')],
      ['address', i18next.t('Address')],
      ['postcode', i18next.t('Postcode')],
      ['next-of-kin', i18next.t('Next of kin')],
      ['fitness-passport', i18next.t('Fitness passport')],
      ['avatar', i18next.t('Profile image')],
    ] satisfies [Dto.MemberField['name'], string][])
    return (
      fields?.map((field) => ({
        ...field,
        label:
          labels.get(field.name) ||
          toCapitalized(field.name.split('-').join(' ')),
      })) || []
    )
  }
}

export { GymBuilderService }
